export const toDays = (ms) => {
  return ms / (60 * 60 * 24 * 1000);
};

const metricsModel = {
  totalOpen: {
    label: 'Open Posts',
    formatter: (value) => `${value} jobs`,
  },
  averageTimeOpen: {
    label: 'Avg. Time Open',
    formatter: (ms) => `${toDays(ms)?.toFixed(0)} days`,
  },
  qualifiedApplicants: {
    label: 'Qualified Applicants',
    formatter: (value) => `${(value * 100.0)?.toFixed(1)} %`,
  },
  averageTimeToFill: {
    label: 'Avg. Time to Fill',
    formatter: (ms) => `${toDays(ms)?.toFixed(1)} days`,
  },
  averageTimeToClose: {
    label: 'Avg. Time to Close',
    formatter: (ms) => `${toDays(ms)?.toFixed(1)} days`,
  },
  averageNumberApplicants: {
    label: 'Avg. # Applicants',
    formatter: (value) => `${value?.toFixed(1)} per post`,
  },
  averageNumberInterviews: {
    label: 'Avg. # Interviews',
    formatter: (value) => `${value?.toFixed(1)} per post`,
  },
  offerAcceptance: {
    label: 'Offer Acceptance',
    formatter: (value) => `${(value * 100.0)?.toFixed(1)} %`,
  },
};

export default metricsModel;
